import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { StoreComponent } from './store/store.component';
import { StoreRoutingModule } from './store.routing.module';
import { ProductModule } from '../product/product.module';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { RefreshComponent } from './refresh/refresh.component';
import { StoreFormComponent } from './store-management/store-form/store-form.component';
import { EditStoreFormComponent } from './store-management/edit-store-form/edit-store-form.component';
import { EditStoreDialogueComponent } from './store-management/edit-store-dialogue/edit-store-dialogue.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { OnboardingDialogComponent } from './onboarding-dialog/onboarding-dialog.component';
import { PublicStoreComponent } from './public-store/public-store.component';
import { SalesComponent } from './sales/sales.component';
import { SalesRowComponent } from './sales/sales-row/sales-row.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { SalesHistoryComponent } from './sales/sales-history/sales-history.component';
import { SalesStatsComponent } from './sales/sales-stats/sales-stats.component';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';

@NgModule({
  declarations: [
    StoreComponent,
    OnboardingComponent,
    RefreshComponent,
    StoreFormComponent,
    EditStoreFormComponent,
    EditStoreDialogueComponent,
    SubscriptionsComponent,
    OnboardingDialogComponent,
    PublicStoreComponent,
    SalesComponent,
    SalesRowComponent,
    SalesHistoryComponent,
    SalesStatsComponent,
  ],
  imports: [
    StoreRoutingModule,
    SharedModule,
    ProductModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatDividerModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
  ],
})
export class StoreModule {}
